import { ChevronDown, ChevronRight } from 'react-feather';
import InfoTooltip from '../common/InfoTooltip';

// Import images
import CarportImg from '../../assets/thumbnails/carport.svg';
import TripleWideImg from '../../assets/thumbnails/Triple-Wide.svg';
import GarageImg from '../../assets/thumbnails/Garage.svg';
import BarnImg from '../../assets/thumbnails/barn.svg';
import OpenBarnImg from '../../assets/thumbnails/Open-Barn.svg'; // Assuming for Straight Line Barn
import UtilityImg from '../../assets/thumbnails/Utility.svg';
import LeanToImg from '../../assets/thumbnails/lean-to.svg';
import RvImg from '../../assets/thumbnails/RV.svg';
// Fallback or specific for Hex/Others if needed
// import WideSpanImg from '../../assets/thumbnails/Wide-Span.svg';

const styleImages = {
    carport: CarportImg,
    tw: TripleWideImg,
    garage: GarageImg,
    barn: BarnImg,
    slbarn: OpenBarnImg,
    utility: UtilityImg,
    hexbarn: BarnImg,
    leanto: LeanToImg,
    rv: RvImg,
    garageleanto: GarageImg,
    openbarn: OpenBarnImg,
    doubleleanto: LeanToImg,
};

export default function OrderStyleSection({
    register,
    styleOptions,
    selectedStyle,
    handleOnChange,
    installationSurfaceOptions,
    roofStyleList,
    selectedRoofStyle,
    handleRoofStyleChange,
    roofPitchOptions,
    selectedRoofPitch,
    handleRoofPitchChange,
    sections,
    toggleSection,
    handleCenterStorageChange,
    centerStorage,
    centerStorageOptions
}) {
    return (
        <div className="tab-information">
            <div className="tab-information-block">
                <div
                    className="title-block"
                    onClick={(e) => toggleSection('styleTab', e)}
                >
                    <h2 className="title-h2">Style</h2>
                    <button type="button">
                        {sections.styleTab ? (
                            <ChevronDown size={24} />
                        ) : (
                            <ChevronRight size={24} />
                        )}
                    </button>
                </div>
                {sections.styleTab && (
                    <div className="new-order-form">
                        <h2 className="tab-subtitle">Building type</h2>
                        <p className="instructions-p">
                            Choose a design from the options below to begin.
                            Afterward, navigate through this and additional tabs to
                            personalize your structure with ease.
                        </p>
                        <h3 className="mb-3 font-bold ">Style</h3>
                        <div className="list-options">
                            <div className="style-selection-grid">
                                {styleOptions.map((option) => (
                                    <button
                                        type="button"
                                        key={option.value}
                                        className={`style-option-button ${
                                            selectedStyle === option.value
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={(e) => {
                                            // Mocking an event object for handleOnChange
                                            // since it expects e.target.value
                                            handleOnChange({
                                                target: { value: option.value },
                                            });
                                        }}
                                    >
                                        <div className="style-image-container">
                                            {styleImages[option.value] && (
                                                <img
                                                    src={styleImages[option.value]}
                                                    alt={option.label}
                                                />
                                            )}
                                        </div>
                                        <div className="style-label">
                                            {option.label}
                                        </div>
                                        {option?.selectedV && (
                                            <div className="style-sublabel">
                                                {option.selectedV}
                                            </div>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <hr className="mb-5" />
                        <div className="field-section-half">
                            <div className="inp-col">
                                <label htmlFor="installationSurface">
                                    <strong>Installation Surface</strong>
                                    <InfoTooltip text="Important for determining the correct anchor type." />
                                </label>
                                <select
                                    {...register('installationSurface', {
                                        defaultValue: 'concrete',
                                    })}
                                    className="select-input"
                                >
                                    {installationSurfaceOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {selectedStyle !== 'slbarn' && (
                                <div className="inp-col">
                                    <label htmlFor="roofStyle">
                                        <strong>Roof style</strong>
                                        <InfoTooltip text="Vertical roof has panels running ridge-to-eave (best for drainage). Standard/A-Frame Horizontal have panels running length-wise." />
                                    </label>
                                    {Array.isArray(roofStyleList) &&
                                    roofStyleList.length > 0 ? (
                                        <select
                                            {...register('roofStyle')}
                                            className="select-input"
                                            value={selectedRoofStyle}
                                            onChange={handleRoofStyleChange}
                                        >
                                            {roofStyleList.map((option) => (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <select
                                            {...register('roofStyle')}
                                            className="select-input"
                                            value={selectedRoofStyle}
                                            onChange={handleRoofStyleChange}
                                        >
                                            {Array.isArray(selectedRoofStyle) &&
                                            selectedRoofStyle.length > 0 ? (
                                                selectedRoofStyle.map((option) => (
                                                    <option
                                                        key={option.value}
                                                        value={option.value}
                                                    >
                                                        {option.label}
                                                    </option>
                                                ))
                                            ) : (
                                                <option value="" disabled>
                                                    No options available
                                                </option>
                                            )}
                                        </select>
                                    )}
                                </div>
                            )}
                        </div>
                        <hr className="mb-5" />
                        <div className="field-section-half">
                            {selectedStyle !== 'hexbarn' &&
                                selectedStyle !== 'leanto' && (
                                    <div className="inp-col">
                                        <label htmlFor="roofPitchOptions">
                                            <strong>Roof pitch</strong>
                                            <InfoTooltip text="Steeper pitch sheds snow/water better but increases peak height." />
                                        </label>
                                        <select
                                            {...register('roofPitchOptions')}
                                            className="select-input"
                                            value={selectedRoofPitch}
                                            onChange={handleRoofPitchChange}
                                        >
                                            {roofPitchOptions.map((option) => (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            {selectedStyle !== 'rv' && (
                                <div className="inp-col">
                                    <label htmlFor="centerStorageOptions">
                                        <strong>Center Storage</strong>
                                        <InfoTooltip text="Enclosed storage area attached to the structure." />
                                    </label>
                                    <select
                                        onChange={handleCenterStorageChange}
                                        className="select-input"
                                        value={centerStorage}
                                    >
                                        {centerStorageOptions.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
